export default __webpack_public_path__ + "static/media/Learning_Event.c9c5b51f.svg";